// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5923":"658f7bdd","8293":"0f10ce67"}[chunkId] + ".chunk.css";
};